export const SET_ADPDONORS = "SET_ADPDONORS";
export const SET_ADPPRINT = "SET_ADPPRINT";
export const SET_ADPBATCHINFOLIST = "SET_ADPBATCHINFOLIST";
export const SET_ADPVOUCHERHOLDERLIST = "SET_ADPVOUCHERHOLDERLIST";